'use client';

import { useApi } from '@prismo-io/core';
import type { SWRArgs } from '@prismo-io/schemas';
import useSWRMutation from 'swr/mutation';
import { type ParamsSchemaT, answerToQuestion } from './answer-to-question';

const B1_QUESTION_ID = '4c09b4e1-8c36-4768-b1db-654dfd6e4169';
const B2_QUESTION_ID = 'b774dc07-7bcd-4b6d-8ba0-8a3345f7a3d5';

export const useAnswerToQuestion = (
  questionId: ParamsSchemaT['questionId']
) => {
  const { client } = useApi();

  return useSWRMutation(
    ['answer-to-question'],
    async (
      key,
      {
        arg,
      }: SWRArgs<
        Pick<ParamsSchemaT, 'answerIds' | 'complement' | 'lookingForContract'>
      >
    ) => {
      const result = await answerToQuestion(client, { questionId, ...arg });

      return result;
    }
  );
};
